import $ from 'jquery';
import "magnific-popup";
import Handlebars from "handlebars";

import Template from '../pages/ll-template.hbs'

$(function () {
    if ($('#locknlist_landing_page').length) {
        $("#btnLL").on('click', (e) => {
            e.preventDefault()
            openPopup()
        });
        $('body').on({
            'click': (e) => {
                e.preventDefault();
                const el = $(e.currentTarget),
                    modal = el.closest('[data-popup]'),
                    select = modal.find('select').val()
                if (!select.length) {
                    modal.find('[data-error]').removeClass('d-none')
                } else {
                    modal.find('[data-error]').addClass('d-none')
                    window.location.replace(select);
                }
            }
        }, '[data-reload-loan]')
        function openPopup() {
            if ($('[data-link-url]').length) {
                let data = [];
                $.each($('[data-link-url] option'), (i, e) => {
                    let items = {}
                    items.url = $(e).attr('value')
                    items.text = $(e).text()
                    data.push(items)
                })
                renderPopup({ 'items': data }).then((html) => {
                    $.magnificPopup.open({
                        items: html,
                        closeBtnInside: true,
                        type: 'inline',

                        callbacks: {
                            markupParse: function (template, values, item) {
                                template.append(item.data)
                            }
                        },
                        inline: {
                            markup: '<div class="white-popup apply-popup">' +
                                '<div class="mfp-close"></div>' +
                                "</div>"
                        },

                        removalDelay: 500,
                        midClick: true
                    });
                })
            }
        }
        function renderPopup(param) {
            return new Promise((resolve, reject) => {
                let source = Template()
                let template = Handlebars.compile(source);
                let html = template(param)

                resolve(html)
            })
        }
    }
});